import React from 'react'
import Card from '@mui/material/Card';
import './quotebox.css';
import Button from '@mui/material/Button';
import QuoteBoxLogic from './QuoteBoxLogic';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const QuoteBox = (props) => {
  const {postButtonWasClicked} = QuoteBoxLogic(props);

  return (
    <Card id="quote-box-container">

<TableContainer id="logo-table"  component={Paper}>
            <Table size="small">
              
            <TableBody>
              <TableRow >
                <TableCell className="table-text-quote" style={{width:'70%',marginLeft:5}}><span>Explore flood insurance options from 28 flood insurance companies.</span></TableCell >
                
                <TableCell className="table-text-quote" style={{width:'30%'}}>
                  <a style={{textDecoration: 'none',align:''}} target={"_blank"} href="https://nationalfloodinsurance.org/quote/?utm_source=website&utm_medium=cpc&utm_campaign=house_transition&utm_id=house_transition_tc">
                    <div style={{textAlign: 'center'}}>
                      <Button className="quote-button" id="the-button" onClick={()=>postButtonWasClicked()}  variant="contained" size="large" fullWidth>
                        <p className="quote-text">Get a Free Quote</p>
                      </Button>
                    </div>
                  </a>
                </TableCell>
              </TableRow>

            </TableBody>
            </Table>
          </TableContainer>
      
        {/* <CardContent style={{marginBottom:-15,marginTop:-25}}>
          <div>
          <p className="twenty-five" style={{fontSize:'large',fontWeight:'bold'}} align='center'>Explore flood insurance options from 28 flood insurance companies.</p>
          
          <a style={{textDecoration: 'none',align:''}} target={"_blank"} href="https://nationalfloodinsurance.org/?utm_source=website&utm_medium=cpc&utm_campaign=zone_change&utm_id=zone_change_tc">
            <div style={{textAlign: 'center'}}><Button id="the-button" onClick={()=>postButtonWasClicked()}  variant="contained" style={{marginTop:-5}}>
              <p className="fifteen" >Get a Free Quote</p>
              <br></br>
            </Button></div>
            </a>
            </div>

        </CardContent> */}

      
      {/* </Collapse> */}
    </Card>

    
   
  ) 
}

export default QuoteBox